

















































































































































































































































import { Component, Vue, Watch, Mixins } from "vue-property-decorator";
import {
  queryOperationBoardAggregate,
  queryOperationOrderBoard,
  queryList,
  queryOperationMember,
} from "@/api/operation";

import Loading from "@/mixins/loading";
import filterTime from "@/utils/filterTime";

@Component
export default class OperationBoard extends Mixins(Loading) {
  fromDate: string = "";
  operationMemberId: number | null = null;
  phone: string = "";
  serviceId: number | null = null;
  subCompanyId: number | null = null;
  toDate: string = "";
  subCompanyList: any[] = [];
  operationServiceList: any[] = [];
  tableOperationSubCompanyList: any[] = [];
  tableOperationServiceList: any[] = [];
  tableOperationMemberList: any[] = [];

  company2service: {} = {};

  currentMonthMemberCount = 0;
  totalMemberCount: any[] = [];
  totalOrderAmount = 0;
  totalOrderCount = 0;
  totalOrderPeople = 0;

  time: string | null = null;
  boardTableHeader = "board-table-header";

  operationMemberList: any[] = [];
  /**
   * 生命周期
   */
  mounted() {
    this.getData();
    this.time = filterTime(Date.now(), "/", ":", false);
  }

  /**
   * methods
   */
  getData(): void {
    this.showLoading();

    queryOperationOrderBoard({
      fromDate: this.fromDate,
      operationMemberId: this.operationMemberId,
      phone: this.phone,
      serviceId: this.serviceId,
      subCompanyId: this.subCompanyId,
      toDate: this.toDate,
    })
      .then((res: any) => {
        this.tableOperationSubCompanyList = res.data.operationSubCompanyList;
        this.tableOperationServiceList = res.data.operationServiceList;
        this.tableOperationMemberList = res.data.operationMemberList;
      })
      .finally(() => {
        this.hideLoading();
      });

    queryList().then((res: any) => {
      this.subCompanyList = res.data;
      this.company2service = res.data.reduce((obj: any, item: any) => {
        obj[item.subCompanyId] = item.operationServiceList;
        return obj;
      }, {});
    });

    queryOperationBoardAggregate().then((res: any) => {
      this.currentMonthMemberCount = res.data.currentMonthMemberCount;
      this.totalMemberCount = this.splitNumber(res.data.totalMemberCount);
      this.totalOrderAmount = res.data.totalOrderAmount;
      this.totalOrderCount = res.data.totalOrderCount;
      this.totalOrderPeople = res.data.totalOrderPeople;
    });
  }

  //按位拆分数字，不够5位补齐
  splitNumber(num: number) {
    //按位拆分数字
    let numArr = num.toString().split("");
    //不够5位补齐
    let numArrLength = numArr.length;
    if (numArrLength < 5) {
      for (let i = 0; i < 5 - numArrLength; i++) {
        numArr.unshift("0");
      }
    }
    return numArr;
  }

  // 搜索
  handleSearch() {
    this.showLoading();
    queryOperationOrderBoard({
      fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
      operationMemberId: this.operationMemberId,
      phone: this.phone,
      serviceId: this.serviceId,
      subCompanyId: this.subCompanyId,
      toDate: this.fromDate && this.fromDate.toString().split(",")[1]
    })
      .then((res: any) => {
        this.tableOperationSubCompanyList = res.data.operationSubCompanyList;
        this.tableOperationServiceList = res.data.operationServiceList;
        this.tableOperationMemberList = res.data.operationMemberList;
      })
      .finally(() => {
        this.hideLoading();
      });
  }

   getManager(queryString: string) {
    queryOperationMember({
      param: queryString,
    }).then((res) => {
      this.operationMemberList = res.data;
    });
  }

  // 输入
  inputValue(val: string, type: string) {
    let self: any = this;
    if (type == "subCompanyId") {
      self[type] = val;
      self.serviceId = null;
      self.operationServiceList = self.company2service[val];
      return;
    }

    self[type] = val;
  }
}
